import { useRef, useState } from 'react'
import { FLAG_COMPLETE_ANIMATION_DELAY_MS } from '../constants'

// Manages the "pin flag to its current tab while the transition animation plays" pattern,
// shared by both ApplicantControlArea and ProcessorControlArea.
export function useAnimatingFlags() {
  const [animatingFlags, setAnimatingFlags] = useState(new Map())
  const animatingFlagsRef = useRef(animatingFlags)
  animatingFlagsRef.current = animatingFlags

  const pinFlag = (flag, activeTab) => {
    setAnimatingFlags((prev) => new Map(prev).set(flag.id, { flag, activeTab, pinnedAt: Date.now() }))
  }

  const unpinFlag = (flag) => {
    setAnimatingFlags((prev) => {
      const next = new Map(prev)
      next.delete(flag.id)
      return next
    })
  }

  // Wait until the animation is completely finished before unpinning, regardless of when the function is called.
  // Uses a ref to avoid stale closure over animatingFlags after the async operation in the caller.
  const unpinFlagAfterAnimation = (flag) => {
    const entry = animatingFlagsRef.current.get(flag.id)
    const elapsed = entry ? Date.now() - entry.pinnedAt : FLAG_COMPLETE_ANIMATION_DELAY_MS
    const remaining = Math.max(0, FLAG_COMPLETE_ANIMATION_DELAY_MS - elapsed)
    setTimeout(() => unpinFlag(flag), remaining)
  }

  return { animatingFlags, setAnimatingFlags, pinFlag, unpinFlagAfterAnimation }
}
